import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import fraazo from "../../Assets/Projects/fraazo.png";
import snapdeal from "../../Assets/Projects/snapdeal.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
          <ProjectCard
              imgPath={fraazo}
              isBlog={false}
              title="fraazo_Clone"
              description="A cloned web application of fraazo website which delivers fresh food to your door steps within stipulated time"
              link="https://github.com/venkat0086/fraazo"
              demo="https://fraazo.netlify.app/"
            />
            
          </Col>

          <Col md={4} className="project-card">
          <ProjectCard
              imgPath={snapdeal}
              isBlog={false}
              title="Snapdeal_Clone"
              description="A cloned web application of snapdeal ,which is an Indian e-commerce application that allows users to purchase various Products"
              link="https://github.com/linkansahu2020/constructive_project2"
              demo="https://distracted-brahmagupta-9fd3ad.netlify.app/"
            />
          
          </Col>
            
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={snapdeal}
              isBlog={false}
              title="Snapdeal_With_Backend"
              description="A cloned web application of snapdeal ,which is an Indian e-commerce application that allows users to purchase various Products"
              link="https://github.com/linkansahu2020/constructive_project2"
              demo="https://distracted-brahmagupta-9fd3ad.netlify.app/"
            />
          </Col>
          

          
          

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
